import { z } from "zod";
import { dmaCanceledCalculationStatusDtoSchema } from "./dma-canceled-calculation-status.schema";
import { dmaFailedCalculationStatusDtoSchema } from "./dma-failed-calculation-status.schema";
import { dmaRunningCalculationStatusDtoSchema } from "./dma-running-calculation-status.schema";
import { dmaSucceededCalculationStatusDtoSchema } from "./dma-succeeded-calculation-status.schema";
import { dmaWaitingCalculationStatusDtoSchema } from "./dma-waiting-calculation-status.schema";
export const dmaCalculationStatusDtoSchema = z.discriminatedUnion("state", [
    dmaRunningCalculationStatusDtoSchema,
    dmaWaitingCalculationStatusDtoSchema,
    dmaSucceededCalculationStatusDtoSchema,
    dmaFailedCalculationStatusDtoSchema,
    dmaCanceledCalculationStatusDtoSchema,
]);
